/**
 * LA FONCTION À AFFICHER SOUS UN NOM — module PUR.
 * ─────────────────────────────────────────────────────────────────────────
 *
 * Sous le nom d'une personne, la RQ veut « juste la fonction » (03/10/2026). Le champ
 * texte `rh-personnel.fonction` ne le donne pas : il cumule le métier, les pilotages et les
 * suppléances (« Technicien supérieur en biologie médicale — pilote Gestion des documents,
 * … — suppléante … »), et il est VIDE pour plusieurs personnes.
 *
 * La fonction proprement dite est celle de l'organigramme : `fonctionIds` pointe des cases
 * d'`orgFonctions` (« Technicien supérieur en biologie médicale », « Biologiste »,
 * « Préleveur »…). On la lit là. Deux fonctions (un préleveur aussi préparateur) s'écrivent
 * ensemble, séparées par « · ».
 *
 * Repli, pour une personne sans case d'organigramme : le PREMIER segment du texte libre —
 * ce qui précède « — » ou « · » — jamais le texte entier.
 */
export function fonctionAffichee(
  p: { fonctionIds?: unknown[] | null; fonction?: string | null },
  orgFonctions?: { id: unknown; label?: unknown }[] | null,
): string {
  const parId = new Map((orgFonctions || []).map((f) => [String(f.id), String(f.label || '').trim()]));
  const libelles: string[] = [];
  for (const id of p.fonctionIds || []) {
    const l = parId.get(String(id));
    if (l && !libelles.includes(l)) libelles.push(l);
  }
  if (libelles.length) return libelles.join(' · ');
  const premier = String(p.fonction || '').split(/\s[—–·]\s/)[0]?.trim();
  return premier || '—';
}
